module.exports = __webpack_public_path__ + "static/media/work.aa6a6680.png";